<div class="row">
  <div class="col" style="text-align: center; font-size: 30px;">
    Enquiry List
  </div>
  <div class="col-2" style="text-align: right;" (click)="closeClicked()">
    <i class="material-icons" style="cursor: pointer; font-size: 28px;">
      cancel
    </i>
  </div>
</div><br>
<div *ngIf="!is_data_available">
  <mat-progress-spinner class="example-margin" [color]="color" [mode]="mode" [diameter]="100">
  </mat-progress-spinner>
</div>
<div class="row">
  <div class="col">
    <table class="table table-bordered table-hover" id="printTable" *ngIf="enquiry_log_data.length !== 0">
      <thead style="background: bisque;">
        <tr>
          <th>S.No</th>
          <th>Name</th>
          <th>Booth / Customer Code</th>
          <th>Requested Time</th>
          <th>Request Status</th>
          <th>RID</th>
          <th>CRN</th>
          <th>Responce Status</th>
          <th>Responce Time</th>
          <th>Transaction Number</th>
          <th>Transacted Time</th>
          <th>Amount</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let enquiry_log of enquiry_log_data; let enquiry_log_index=index">
          <td [style.border-left]="checkBorderColor(enquiry_log['responce_status_name'])">{{ enquiry_log_index + 1}}</td>
          <td>{{ enquiry_log['first_name']}} {{enquiry_log['last_name']}}</td>
          <td>{{ enquiry_log['booth_or_customer_code']}}</td>
          <td>{{ enquiry_log['request_time_created'] | date: 'short'}}</td>
          <td>{{ enquiry_log['request_status_name']}}</td>
          <td>{{ enquiry_log['rid']}}</td>
          <td>{{ enquiry_log['request_crn']}}</td>
          <td *ngIf="enquiry_log.responce_status_name !== 0">{{ enquiry_log['responce_status_name']}}</td>
          <td *ngIf="enquiry_log.responce_status_name == 0">-</td>
          <td *ngIf="enquiry_log.responce_status_name !== 0">{{ enquiry_log['responce_time_created'] | date: 'short'}}
          </td>
          <td *ngIf="enquiry_log.responce_status_name == 0">-</td>
          <td *ngIf="enquiry_log.responce_status_name !== 0">{{ enquiry_log['trn']}}</td>
          <td *ngIf="enquiry_log.responce_status_name == 0">-</td>
          <td *ngIf="enquiry_log.responce_status_name !== 0">{{ enquiry_log['tet'] | date: 'short'}}</td>
          <td *ngIf="enquiry_log.responce_status_name == 0">-</td>
          <td *ngIf="enquiry_log.responce_status_name !== 0">{{ enquiry_log['amt']  | currency: 'INR'}}</td>
          <td *ngIf="enquiry_log.responce_status_name == 0">-</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
<div class="row">
  <div class="col" style="text-align: center;">
    <button mat-button style="background-color: coral; color: white;" (click)="makeEnquiry()">Make Enquiry</button>
  </div>
</div>
